import script from "./MDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./MDashboard.vue?vue&type=script&setup=true&lang=js"

import "./MDashboard.vue?vue&type=style&index=0&id=4d2d14ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d2d14ba"]])

export default __exports__